import axios from 'axios';

export const getToken = () => {
    return '';
};

axios.defaults.baseURL =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? `https://vserve-api.valet2you.in/`
        : `https://test-vserve-api.valet2you.in/`;

axios.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (token) {
            config.headers.common['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const { response } = error;
        const { request, ...errorObject } = response;
        if (errorObject.status === 401) {
            window.location.replace('/');
        }

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

export const getHotelDetails = () => {
    const hotelID = localStorage.getItem('hotel_id');
    return axios.get(
        `api/v5.0.1/restaurant_server/details/${hotelID}`
    );
};
export const saveGuestDetails = (payload) => {
    const hotelID = localStorage.getItem('hotel_id');
    return axios.post(
        `api/v5.0.1/restaurant_server/contact-entry/${hotelID}`,
        payload
    );
};
export const getContactBook = (searchValue, selectedOutelet) => {
    const hotelID = localStorage.getItem('hotel_id');
    let QRParams = '?';
    if (searchValue) {
        QRParams += `search=${searchValue}&`;
    }
    if (selectedOutelet) {
        QRParams += `outlet_id=${selectedOutelet}&`;
    }
    return axios.get(
        `api/v5.0.1/restaurant_server/contact-book/${hotelID}${QRParams}per_page=200`
    );
};
export const getVisitorHistory = (searchValue, selectedOutelet) => {
    const hotelID = localStorage.getItem('hotel_id');
    let QRParams = '?';
    if (searchValue) {
        QRParams += `search=${searchValue}&`;
    }
    if (selectedOutelet) {
        QRParams += `outlet_id=${selectedOutelet}&`;
    }
    return axios.get(
        `api/v5.0.1/restaurant_server/history-book/${hotelID}${QRParams}per_page=200`
    );
};

export const getUserDetailsIfRegistered = (value) => {
    const hotelID = localStorage.getItem('hotel_id');
    return axios.get(
        `api/v5.0.1/restaurant_server/individual-visitor/${hotelID}?mobile=${value}`
    );
};
